<form class="sample-form validations-form" [formGroup]="validations_form">
  <ion-item lines="none" class="border">
    <div class="ion-padding-start ion-padding-top titulo">
      <ion-label class="bold-1"> {{'Nome' | translate}} </ion-label>

      <ion-input
        label=""
        label-placement="stacked"
        [(ngModel)]="atividade.nome"
        readonly
        formControlName="nome"
        type="text"
      ></ion-input>
    </div>
  </ion-item>

  <ion-item class="notas-atividades" lines="none">
    <ion-label class="nota-text" position="floating">
      {{'Nota' | translate}}
      <span class="danger">*</span>
    </ion-label>

    <ion-select
      label=""
      label-placement="stacked"
      toggleIcon="caret-down-sharp"
      interface="action-sheet"
      cancelText="{{ 'Cancelar' | translate}}"
      okText="{{ 'Confirmar' | translate}}"
      [(ngModel)]="atividade.nota"
      formControlName="nota"
    >
      <ion-select-option
        *ngFor="let in of counter((atividade.valor*1)+1); let i = index"
        [value]="i"
        >{{i}}
      </ion-select-option>
    </ion-select>
  </ion-item>
</form>
